<template>
    <div class="pt-10 aboutus">
        <TwoColumnLayout>
            <template v-slot:banner>
                <Banner :data="getBrandBanner()" :single="true" />
            </template>
            <template v-slot:title>
                <!-- <h1 class="rbtitle mt-4 mt-sm-0 mb-4">{{this.AboutTitle}}</h1> -->
            </template>
            <template v-slot:filters>
            </template>
            <template v-slot:form-content>
                <div class="container-fluid px-3">
                    <div class="row" v-if="this.MissionStatement">
                        <div class="subHeading section-heading">
                            {{this.MissionTitle}}
                        </div>
                        <div class="details">
                            {{this.MissionStatement}}
                        </div>
                    </div>
                    <div class="row" v-if="this.History">
                        <div class="subHeading section-heading">
                            {{this.HistoryTitle}}
                        </div>
                        <div class="details">
                            {{this.History}}
                        </div>
                    </div>
                    <div class="row">
                        <div class="section-heading px-0">
                            {{this.OurTeamTitle}}
                        </div>
                        <div class="details">
                            <members-list />
                        </div>                        
                    </div>
                </div>                
            </template>
            <template v-slot:address>
                <contact-address />
            </template>
        </TwoColumnLayout>
    </div>
</template>
<script>
    import MembersList from '../components/molecules/MembersList.vue'
    import TwoColumnLayout from "../components/molecules/TwoColumnLayout.vue";
    import ContactAddress from "../components/molecules/ContactAddress.vue";
    import {aboutTitle,missionTitle, historyTitle,ourTeamTitle} from '../constants/labels.config'; 
    import Banner from '../components/molecules/CarouselBanner.vue';
    import getBannerData from '../constants/banner.config';
    export default {
        name: "AboutPage",
        data(){
            return{
                AboutTitle:aboutTitle,
                MissionTitle:missionTitle,
                HistoryTitle:historyTitle,
                OurTeamTitle:ourTeamTitle,
                MissionStatement:window.DEALER_LOCATION.missionStatement,
                History:window.DEALER_LOCATION.history,
            }
        },
        components: {
            MembersList,
            TwoColumnLayout,
            ContactAddress,
            Banner,
        },
        methods:{
            getBrandBanner(){
                return getBannerData(sessionStorage.getItem('brand'), 'about_us');
            },
        }
    };
</script>